import ColorPicker from './ColorPicker';

export default ColorPicker;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/color-picker/index.js
// module id = 360
// module chunks = 0